import { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { database } from "./firebase";
import { jsPDF } from "jspdf";

function Exercises() {
    const [chooseWords, setChooseWords] = useState([]);
    const [inputVerbType1, setInputVerbType1] = useState([]);
    const [currentExercise, setCurrentExercise] = useState("");
    const [spanishType, setSpanishType] = useState("");
    const [type, setType] = useState("");
    const [subType, setSubType] = useState("");

    useEffect(()=>{
            const pathToChooseWords = collection(database, "ChooseWords")
            const pathToInputVerbType1 = collection(database, "InputVerbType1")
            const getExercises = async() => {
                const dbDataChooseWords = await getDocs(pathToChooseWords);
                let receivedDataChooseWords = dbDataChooseWords.docs.map(doc=>({...doc.data(), id:doc.id}));
                setChooseWords(receivedDataChooseWords);
                // console.log(receivedDataChooseWords)

                const dbDataInputVerbType1 = await getDocs(pathToInputVerbType1);
                let receivedDataInputVerbType1 = dbDataInputVerbType1.docs.map(doc=>({...doc.data(), id:doc.id}));
                setInputVerbType1(receivedDataInputVerbType1);
                // console.log(receivedDataInputVerbType1)
            }
            getExercises();
            
            
    },[]);

    const chooseCurrentExerciseHandle = async (e) => {
        setCurrentExercise(e.target.value);
    };

    const chooseSpanishTypeHandle = async (e) => {
        setSpanishType(e.target.value);
    };

    const chooseTypeHandle = async (e) => {
        setType(e.target.value);
    };

    const chooseSubTypeHandle = async (e) => {
        setSubType(e.target.value);
    };

    // const filteredChooseWords = chooseWords?.filter(task => {
    //     return (
    //         (!spanishType || task.spanishType === spanishType) &&
    //         (!type || task.type === type) &&
    //         (!subType || task.subtype === subType)
    //     );
    // });

    const filteredChooseWords = chooseWords?.filter(task => {
        if (!spanishType || !type) return false; // Исключаем, если нет ключевых параметров
    
        // Если subType пустой, не учитывать его при фильтрации
        const subtypeMatch = subType ? task.subtype === subType : true;
    
        // Если выбран "rioplat", берем только "rioplat" и "common", но исключаем "common", если altRioplatID не пустой
        if (spanishType === "rioplat") {
            return (
                (task.spanishType === "rioplat" || 
                (task.spanishType === "common" && !task.altRioplatID)) &&
                task.type === type &&
                subtypeMatch
            );
        }
    
        // Фильтрация по обычным условиям
        return (
            task.spanishType === spanishType &&
            task.type === type &&
            subtypeMatch
        );
    });

    const filteredInputVerbType1 = inputVerbType1?.filter(task => {
        if (!spanishType || !type || !subType) return false; // Исключаем, если нет ключевых параметров
    
        // Если выбран "rioplat", берем только "rioplat" и "common", но исключаем "common", если altRioplatID не пустой
        if (spanishType === "rioplat") {
            return (
                (task.spanishType === "rioplat" || 
                (task.spanishType === "common" && !task.altRioplatID)) &&
                task.type === type &&
                task.subtype === subType
            );
        }
    
        // Фильтрация по обычным условиям
        return (
            task.spanishType === spanishType &&
            task.type === type &&
            task.subtype === subType
        );
    });

    function generatePDF(data) {
        const doc = new jsPDF();
    
        var formatedType = "";
        if (type === "llevarTraer") {
            formatedType = "Llevar / Traer";
        } else if (type === "articles") {
            formatedType = "Artículos";
        } else if (type === "porPara") {
            formatedType = "Por / Para";
        } else if (type === "adjectives") {
            formatedType = "Adjetivos";
        } else if (type === "prepositions") {
            formatedType = "Preposiciones";
        } else if (type === "connectors") {
            formatedType = "Conectores";
        } else if (type === "odOi") {
            formatedType = "Objeto Directo / Objeto Indirecto";
        } else if (type === "hayEstar") {
            formatedType = "Hay / Estar";
        } else if (type === "verbosDeCambio") {
            formatedType = "Verbos de cambio";
        } else if (type === "indSubj") {
            formatedType = "Indicativo / Subjuntivo";
        } else if (type === "tenses") {
            formatedType = "Conjugación";
        } else if (type === "pronombres") {
            formatedType = "Pronombres";
        } else if (type === "condicionales") {
            formatedType = "Condicionales";
        }

        var formatedSubtype = "";
        if (subType === "adjectivesRightOrder") {
            formatedSubtype = "ordenar correctamente";
        } else if (subType === "deDesde") {
            formatedSubtype = "de / desde";
        } else if (subType === "isZeroArticle") {
            formatedSubtype = "¿Con artículo o sin artículo?";
        } else if (subType === "sinEmbargo-aunque-aPesarDe") {
            formatedSubtype = "sin embargo / aunque / a pesar de";
        } else if (subType === "allTenses") {
            formatedSubtype = "todos los tiempos de subjuntivo";
        } else if (subType === "connectorsOfCause1") {
            formatedSubtype = "conectores de causa";
        } else if (subType === "chooseArticleA1") {
            formatedSubtype = "elegir un artículo";
        } else if (subType === "presenteIndSubj") {
            formatedSubtype = "presente";
        } else if (subType === "porParaPorqueParaQue") {
            formatedSubtype = "por / para / porque / para que";
        } else if (subType === "presenteDeIndicativoInputA1") {
            formatedSubtype = "presente de indicativo";
        } else if (subType === "preteritoImperfectoInputA2") {
            formatedSubtype = "pretérito imperfecto";
        } else if (subType === "presenteDeSubjuntivoInputB1") {
            formatedSubtype = "presente de subjuntivo";
        } else if (subType === "gradosDelAdjetivo") {
            formatedSubtype = "grados del adjetivo";
        } else if (subType === "imperativoAfirmativoInputA2") {
            formatedSubtype = "imperativo afirmativo";
        } else if (subType === "imperativoNegativoInputA2") {
            formatedSubtype = "imperativo negativo";
        } else if (subType === "pronombresRelativosC1") {
            formatedSubtype = "Pronombres Relativos";
        } else if (subType === "adjectivesByContext") {
            formatedSubtype = "Elegir por contexto";
        } else if (subType === "typeCond3") {
            formatedSubtype = "Tipo 3";
        } else if (subType === "typeCond2") {
            formatedSubtype = "Tipo 2";
        } else if (subType === "typeCond1") {
            formatedSubtype = "Tipo 1";
        } else if (subType === "typeCondMix") {
            formatedSubtype = "Tipo mixto";
        }
        
        // Настройки документа
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 10;
        const contentWidth = pageWidth - 2 * margin;
    
        // Шапка документа
        doc.setFontSize(18);
        doc.text(`${formatedType}`, margin, 20);
        doc.text(`${formatedSubtype}`, margin, 30);
        
    
        // Разделитель
        doc.setDrawColor(150);
        doc.setLineWidth(0.5);
        doc.line(margin, 24, pageWidth - margin, 24);
    
        // Данные
        let yPosition = 45; // Начальная позиция по вертикали
        const lineHeight = 8;
        const optionSpacing = 50; // Расстояние между вариантами по горизонтали
    
        data.forEach((task, index) => {
            if (yPosition > pageHeight - margin) {
                doc.addPage();
                yPosition = margin + 10;
            }
    
            // Вопрос
            doc.setFontSize(10);
            doc.text(`${index + 1}.  ${task.words.join(" ")}`, margin, yPosition);
            yPosition += lineHeight;
    
            // Варианты ответов
            let xPosition = margin;
            if (currentExercise === "ChooseWords") {
                task.options.forEach((option, idx) => {
                    doc.text(`${String.fromCharCode(97 + idx)}: ${option}`, xPosition, yPosition);
                    xPosition += optionSpacing; // Увеличиваем x для следующего варианта
                });
            } else if(currentExercise === "InputVerbType1") {
                doc.text(`______________`, xPosition, yPosition);
                    xPosition += optionSpacing; // Увеличиваем x для следующего варианта
            }
    
            yPosition += lineHeight; // Переходим на следующую строку для разделителя
    
            // Разделитель между задачами
            doc.setDrawColor(150);
            doc.setLineWidth(0.1);
            doc.line(margin, yPosition, pageWidth - margin, yPosition);
            yPosition += lineHeight;
        });
    
        // Сохранение PDF
        doc.save("exercises_report.pdf");
    }
    

    const handleDownloadPDF = () => {
        if (currentExercise === "ChooseWords") {
            generatePDF(filteredChooseWords);
            console.log("chooseWords")
        } else if(currentExercise === "InputVerbType1") {
            generatePDF(filteredInputVerbType1);
            console.log("inputVerbType1")
        } else {
            console.log("Ошибка: оба массива пустые или не определены!");
        }
    };

    return (
        <div className="w-full mt-24">
            <div className="flex items-center flex-col">
                <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-1/2">
                <select onChange={chooseCurrentExerciseHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option hidden disabled selected value='0'>Выберите тип упражнения</option>
                    <option value='ChooseWords'>ChooseWords</option>
                    <option value='InputVerbType1'>InputVerbType1</option>
                </select>
                {currentExercise === "ChooseWords" ? 
                <div className="flex flex-row space-x-2">
                    <select onChange={chooseSpanishTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">Spanish Type</option>
                        {chooseWords ? (
                            [...new Set(chooseWords.map(task => task.spanishType))]
                                .map((spanishType, index) => (
                                    <option key={index} value={spanishType}>
                                        {spanishType}
                                    </option>
                                ))
                        ) : ""}
                    </select>

                    <select onChange={chooseTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">Type</option>
                        {chooseWords ? (
                            [...new Set(chooseWords.map(task => task.type))]
                                .map((type, index) => (
                                    <option key={index} value={type}>
                                        {type}
                                    </option>
                                ))
                        ) : ""}
                    </select>

                    <select onChange={chooseSubTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">subtype</option>
                        {chooseWords ? (
                            [...new Set(chooseWords.map(task => task.subtype))]
                                .map((subtype, index) => (
                                    <option key={index} value={subtype}>
                                        {subtype}
                                    </option>
                                ))
                        ) : ""}
                    </select>
                </div> : ""}

                {currentExercise === "InputVerbType1" ? 
                <div className="flex flex-row space-x-2">
                    <select onChange={chooseSpanishTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">Spanish Type</option>
                        {inputVerbType1 ? (
                            [...new Set(inputVerbType1.map(task => task.spanishType))]
                                .map((spanishType, index) => (
                                    <option key={index} value={spanishType}>
                                        {spanishType}
                                    </option>
                                ))
                        ) : ""}
                    </select>

                    <select onChange={chooseTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">Type</option>
                        {inputVerbType1 ? (
                            [...new Set(inputVerbType1.map(task => task.type))]
                                .map((type, index) => (
                                    <option key={index} value={type}>
                                        {type}
                                    </option>
                                ))
                        ) : ""}
                    </select>

                    <select onChange={chooseSubTypeHandle} id="selection" className="mt-4 block appearance-none bg-gray-100 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option hidden disabled selected value="0">subtype</option>
                        {inputVerbType1 ? (
                            [...new Set(inputVerbType1.map(task => task.subtype))]
                                .map((subtype, index) => (
                                    <option key={index} value={subtype}>
                                        {subtype}
                                    </option>
                                ))
                        ) : ""}
                    </select>
                </div> : ""}
                <div className="text-right">
                    <button
                        onClick={handleDownloadPDF}
                        className="m-1 px-4 py-2 bg-blue-500 text-white rounded"
                    >
                        Скачать pdf
                    </button>
                </div>
                </div>
            </div>
        </div>
    )
}

export default Exercises